import axios from 'axios';

export const DynamicDashboardService = {
  levelDetailsGET: () => axios.get(`/DynamicDashboard`),
  getDetailsbasedOnParent: ({ levelId }: { levelId: string }) =>
    axios.get(`DynamicDashboard/successiveLevel`, {
      params: { parentId: levelId },
    }),
  getChartDetails: ({ name, type }: { name: string; type: string }) =>
    axios.get(`/DynamicDashboard/Charts`, { params: { name, type } }),
  assignUserMaster: (assetId: string, UserId: string) =>
    axios.post<any>(
      `/MasterReport/AddUser?assetId=${assetId}&UserId=${UserId}`,
    ),
};
